import { Container, Card } from "@mui/material";
import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import Page from "../../Page";
import { PaymentStatusContainer } from "../QRScanner/PaymentStatusContainer";
import { cmsBaseUrlV1 } from "../../../react-query/endpoints";
export const PaymentResponse = () => {
  const [searchParams] = useSearchParams();
  // HDFC referenceId format changed to: HDFC-{timestamp}-{chargerId}-{connectorId}-{user_pk}
  // Old format was: HDFC-{chargerId}-{connectorId}
  // PTM format remains: PTM-{chargerId}-{connectorId}
  const referenceIdRaw = searchParams.get("referenceId") ?? "";
  const refParts = referenceIdRaw.split("-");
  const isNewHdfcFormat =
    referenceIdRaw.startsWith("HDFC-") &&
    refParts.length >= 5 &&
    /^\d{10,}$/.test(refParts[1]);
  const chargerId = isNewHdfcFormat ? refParts[2] : refParts[1];
  const connectorId = isNewHdfcFormat ? refParts[3] : refParts[2];

  const message =
    searchParams.get("status") === "paid"
      ? "Payment is successful! Please wait, charger will start in a while."
      : "Error";

  // Extract user_pk from URL
  const user_pk = searchParams.get("user_pk") ?? "";

  // Check if this is a Paytm transaction (referenceId starts with "PTM-")
  const isPaytmTransaction = referenceIdRaw.startsWith("PTM-");
  const isHDFCTransaction = referenceIdRaw.startsWith("HDFC-");

  // State for user details
  const [email, setEmail] = useState(isPaytmTransaction ? "" : searchParams.get("email") ?? "");
  const [phone, setPhone] = useState(isPaytmTransaction ? "" : searchParams.get("phone") ?? "");
  const [loading, setLoading] = useState(false);

  const isAllowedGateway = isPaytmTransaction || isHDFCTransaction;

  useEffect(() => {
    const fetchUserDetails = async () => {
      // Only fetch for Paytm and HDFC transactions
      if (!isAllowedGateway) {
        return;
      }

      // ALWAYS fetch if we have user_pk (ignore emailFromUrl/phoneFromUrl)
      if (user_pk) {
        setLoading(true);
        try {
          const apiUrl = `${cmsBaseUrlV1}/user/public/${user_pk}`;
          
          const response = await fetch(apiUrl);
          
          if (response.ok) {
            const result = await response.json();
            
            if (result.success && result.data) {
              setEmail(result.data.e_mail || "");
              setPhone(result.data.phone || "");
            }
          } else {
            console.error("API request failed with status:", response.status);
          }
        } catch (error) {
          console.error("Error fetching user details:", error);
        } finally {
          setLoading(false);
        }
      }
    };

    fetchUserDetails();
  }, [user_pk, isPaytmTransaction]);

  // Handle closing popup if in child window (HDFC flow)
  /* useEffect(() => {
    if (!isHDFCTransaction) {
      return;
    }
    // Check if this window was opened by another window
    if (window.opener && window.opener !== window) {
      try {
        console.log("Detected popup window, attempting to update parent and close...");

        // Redirect the parent window to the current status page so user sees result
        // wrapped in try-catch in case of cross-origin issues (though detecting opener usually implies same-origin or allowed)
        try {
          window.opener.location.href = window.location.href;
        } catch (e) {
          console.warn("Could not redirection parent window:", e);
        }

        // Close this popup window
        window.close();
      } catch (error) {
        console.error("Failed to close popup:", error);
      }
    }
  }, [isHDFCTransaction]); */

  return (
    <Page
      title="Payment Status | ChargeMiles"
      sx={{ minHeight: "100vh", display: "flex", alignItems: "center", overflow: "hidden" }}
    >
      <Container maxWidth="sm" sx={{ py: 4 }}>
        <Card sx={{ 
          p: { xs: 3, md: 5 },
          boxShadow: (theme) => `0 0 4px 0 rgba(145,158,171,0.24), 0 24px 48px 0 rgba(145,158,171,0.24)`,
          borderRadius: 3,
          textAlign: "center"
        }}>
          <PaymentStatusContainer
            chargerId={chargerId}
            connectorId={connectorId}
            status={searchParams.get("status") === "paid"}
            message={message}
            email={email}
            phone={phone}
          />
        </Card>
      </Container>
    </Page>
  );
};